import './scss/index.scss';
import { dcFactory } from '@deleteagency/dc';
import ContentBlockNew from './js/content-block-new';
dcFactory.register(ContentBlockNew);